import { render, staticRenderFns } from "./WordsField.vue?vue&type=template&id=0ee364b3&lang=pug&"
import script from "./WordsField.vue?vue&type=script&lang=js&"
export * from "./WordsField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports